<div class="lum-modal lum-c-sales-order-pull-order-form">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Pull Order</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="form"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Select app integration account to pull order</label>
            <mat-select
              class="lum-select"
              formControlName="appIntegrationAccountId"
              [ngClass]="{
                error:
                  form.get('appIntegrationAccountId')?.invalid &&
                  form.get('appIntegrationAccountId')?.touched,
              }"
              (selectionChange)="onAppIntegrationAccountChange($event)"
            >
              <mat-option
                *ngFor="let item of appIntegrationAccounts; trackBy: trackById"
                [value]="item.id"
              >
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('appIntegrationAccountId')?.invalid">
              {{ form.get('appIntegrationAccountId') | validateField }}
            </mat-error>
          </div>
          <div class="form-group" *ngIf="isOmsStoreRequired">
            <label for="">Select app integration account store</label>
            <mat-select
              class="lum-select"
              formControlName="omsStoreId"
              [ngClass]="{
                error:
                  form.get('omsStoreId')?.invalid &&
                  form.get('omsStoreId')?.touched,
              }"
            >
              <mat-option
                *ngFor="let item of selectedAccountOmsStores; trackBy: trackById"
                [value]="item.storeId"
              >
                {{ item.storeName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('omsStoreId')?.invalid">
              {{ form.get('omsStoreId') | validateField }}
            </mat-error>
          </div>
          <div class="form-group pb-1">
            <label>{{ selectedAppIntegrationAccountIdFieldLabel }}</label>
            <input class="form-control" type="text" formControlName="orderId" />
            <control-messages
              [submitted]="loading"
              [control]="form.controls.orderId"
            >
            </control-messages>
          </div>
          <div class="form-group form-check pb-1">
            <mat-checkbox formControlName="applyMapping" color="primary">
              Apply Mappings & Show Luminous Object
            </mat-checkbox>
          </div>

          <div class="form-group mt-3">
            <div class="ai-debug-options">
              <div class="ai-debug-option">
                <mat-checkbox formControlName="analyzeMapping" color="primary">
                  Analyze Mapping Issues with AI
                </mat-checkbox>
                <div class="ai-debug-description">
                  Examines source data against current mappings to identify and
                  explain potential issues
                </div>
              </div>

              <div class="ai-debug-option mt-3">
                <mat-checkbox
                  formControlName="testMapping"
                  color="primary"
                  (change)="onTestMappingChange($event)"
                >
                  Test Specific Field Mapping
                </mat-checkbox>
                <div class="ai-debug-description">
                  Tests a specific mapping with AI-powered suggestions for
                  improvement
                </div>

                <div
                  *ngIf="form.get('testMapping')?.value"
                  class="mapping-test-fields"
                >
                  <div class="form-group mt-2">
                    <label>Source Field (JSONPath)</label>
                    <input
                      class="form-control"
                      type="text"
                      formControlName="sourceField"
                      placeholder='e.g., line_items[*].properties[?(@.name=="Shipdate")].value'
                    />
                    <small class="form-text text-muted"
                      >JSONPath expression to extract data from source</small
                    >
                  </div>

                  <div class="form-group mt-2">
                    <label>Target Field (Luminous Path)</label>
                    <input
                      class="form-control"
                      type="text"
                      formControlName="targetField"
                      placeholder="e.g., orderItems[*].estimated_ship_date"
                    />
                    <small class="form-text text-muted"
                      >Path to the target field in Luminous data model</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <mat-divider class="mt-3"></mat-divider>

          <!-- Results section with tabs -->
          <div class="form-group pt-7" *ngIf="hasOrderData">
            <mat-tab-group
              animationDuration="0ms"
              [selectedIndex]="activeTabIndex"
              (selectedIndexChange)="setActiveTab($event)"
            >
              <!-- Order Data Tab -->
              <mat-tab label="Order Data">
                <div class="tab-content">
                  <div class="json-viewer-container">
                    <div class="json-viewer-header">
                      <span class="json-viewer-title">Order Data</span>
                      <div class="json-viewer-actions">
                        <button
                          mat-icon-button
                          (click)="toggleAllNodes()"
                          type="button"
                        >
                          <mat-icon>{{
                            expandAll ? 'unfold_less' : 'unfold_more'
                          }}</mat-icon>
                        </button>
                        <button
                          mat-icon-button
                          (click)="copyJsonToClipboard()"
                          type="button"
                        >
                          <mat-icon>content_copy</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div class="json-viewer">
                      <div
                        *ngFor="let node of jsonNodes; let i = index"
                        class="json-node"
                      >
                        <div
                          class="json-node-content"
                          [class.json-node-collapsed]="!node.expanded"
                          [style.padding-left.px]="node.level * 20"
                        >
                          <button
                            *ngIf="node.hasChildren"
                            type="button"
                            class="json-node-toggle"
                            (click)="toggleNode(i)"
                          >
                            <mat-icon class="json-toggle-icon">{{
                              node.expanded ? 'expand_more' : 'chevron_right'
                            }}</mat-icon>
                          </button>
                          <span class="json-key">{{ node.key }}</span>
                          <span class="json-separator" *ngIf="node.hasChildren">{{
                            node.isArray ? '[' : '{'
                          }}</span>
                          <span
                            class="json-value"
                            *ngIf="!node.hasChildren"
                            [ngClass]="getValueType(node.value)"
                            >{{ getFormattedValue(node.value) }}</span
                          >
                          <span
                            class="json-length"
                            *ngIf="node.hasChildren && !node.expanded"
                          >
                            {{ node.childCount }}
                            {{ node.isArray ? 'items' : 'properties' }}
                          </span>
                          <span
                            class="json-separator"
                            *ngIf="node.hasChildren && !node.expanded"
                            >{{ node.isArray ? ']' : '}' }}</span
                          >
                        </div>
                        <div
                          class="json-node-close"
                          *ngIf="
                            node.hasChildren && node.expanded && node.isLastChild
                          "
                          [style.padding-left.px]="node.level * 20"
                        >
                          {{ node.isArray ? ']' : '}' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <!-- Analysis Results Tab (visible only when analysis data exists) -->
              <mat-tab label="Mapping Analysis" *ngIf="markdownAnalysis">
                <div class="tab-content">
                  <div class="markdown-container">
                    <div class="markdown-header">
                      <span class="markdown-title">AI Mapping Analysis</span>
                    </div>
                    <div
                      class="markdown-content"
                      [innerHTML]="markdownAnalysis"
                    ></div>
                  </div>
                </div>
              </mat-tab>

              <!-- Mapping Test Results Tab (visible only when test results exist) -->
              <mat-tab label="Test Results" *ngIf="testMappingResult">
                <div class="tab-content">
                  <div class="mapping-test-container">
                    <div class="mapping-test-header">
                      <span class="mapping-test-title"
                        >Field Mapping Test Results</span
                      >
                    </div>
                    <div class="mapping-test-content">
                      <div class="mapping-test-item">
                        <div class="mapping-field">
                          <span class="mapping-label">Source Field:</span>
                          <span class="mapping-value">{{
                            testMappingResult.sourceField
                          }}</span>
                        </div>
                        <div class="mapping-field">
                          <span class="mapping-label">Source Exists:</span>
                          <span
                            class="mapping-value"
                            [ngClass]="
                              testMappingResult.sourceExists ? 'success' : 'error'
                            "
                          >
                            {{ testMappingResult.sourceExists ? 'Yes' : 'No' }}
                          </span>
                        </div>
                        <div class="mapping-field">
                          <span class="mapping-label">Extracted Value:</span>
                          <span class="mapping-value">{{
                            testMappingResult.extractedValue | json
                          }}</span>
                        </div>
                        <div class="mapping-field">
                          <span class="mapping-label">Target Field:</span>
                          <span class="mapping-value">{{
                            testMappingResult.targetField
                          }}</span>
                        </div>
                        <div class="mapping-field">
                          <span class="mapping-label">Mapped Value:</span>
                          <span class="mapping-value">{{
                            testMappingResult.mappedValue | json
                          }}</span>
                        </div>
                        <div class="mapping-field">
                          <span class="mapping-label">Success:</span>
                          <span
                            class="mapping-value"
                            [ngClass]="
                              testMappingResult.success ? 'success' : 'error'
                            "
                          >
                            {{ testMappingResult.success ? 'Yes' : 'No' }}
                          </span>
                        </div>
                        <div
                          class="mapping-field"
                          *ngIf="testMappingResult.suggestion"
                        >
                          <span class="mapping-label">Suggestion:</span>
                          <span class="mapping-value">{{
                            testMappingResult.suggestion
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="form.invalid || loading"
          >
            Pull Order
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
